<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="评估机构">
          <el-input
            placeholder="请输入评估机构"
            v-model="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="评估状态">
          <el-select
            v-model="ruleForm.status"
            placeholder="请选择评估状态"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in pagestatus"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <div>
        <span
          class="
            attention
            margin-top10 margin-bot10 margin-left20 margin-right20
          "
          @click="Initiateasale()"
          >新 增</span
        >
      </div>
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20 pad-top20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="pages"
            stripe
            style="width: 98%"
            class="eltable margin-auto f14"
          >
            <el-table-column label="成果名称" v-if="columns[0].visible">
              <template slot-scope="scope">
                <span
                  class="f14 cursorpointer bluecolor text-ellipsis"
                  @click="initiatedetail(scope.row)"
                >
                  {{
                    scope.row.achievements == null
                      ? ""
                      : scope.row.achievements.title
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="估值申请时间"
              v-if="columns[1].visible"
            >
            </el-table-column>
            <el-table-column label="评估状态" v-if="columns[2].visible">
              <template slot-scope="scope">
                <span class="f14 cursorpointer text-ellipsis">
                  <span
                    :class="scope.row.status == 1 ? 'grenn' : 'grenns'"
                  ></span>
                  {{ scope.row.status == 1 ? "待评估" : "已评估" }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="report_agency"
              label="评估机构"
              v-if="columns[3].visible"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="评估值( 万元 )"
              v-if="columns[4].visible"
            >
            </el-table-column>
            <el-table-column label="操作" v-if="columns[5].visible">
              <template slot-scope="scope">
                <span
                  class="cursorpointer margin-left10 bluecolor"
                  v-if="scope.row.status == 1 ? true : false"
                  @click="Initiateedit(scope.row)"
                  >编辑</span
                >
                <span
                  class="f14 cursorpointer margin-left10 bluecolor"
                  v-if="scope.row.status == 1 ? true : false"
                  @click="Submitfromnull(scope.row)"
                >
                  <span>删除</span>
                </span>
                <span
                  class="cursorpointer margin-left10 bluecolor"
                  v-if="scope.row.status == 2 ? true : false"
                  @click="downloadreport(scope.row)"
                  >评估报告</span
                >
                <span
                  class="cursorpointer margin-left10 bluecolor"
                  v-if="scope.row.status == 2 ? true : false"
                  @click="financing(scope.row)"
                  >项目融资</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="parseInt(per_page)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiintroduction"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <p class="textalign-left f18">新增成果估值</p>
      <div class="textalign-left margin-top30">
        <div>
          <p>成果名称</p>
          <el-select
            v-model="achievement"
            placeholder="请选择成果"
            class="width100 margin-top10"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in achievements"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p class="margin-top20">备注信息</p>
          <el-input
            placeholder="请输入备注信息"
            v-model="remark"
            type="textarea"
            :autosize="autosize"
            class="inputDeep margin-top10"
            maxlength="500"
            rows="5"
            cols="20"
          >
          </el-input>
        </div>
      </div>
      <div class="but-box textalign-right margin-top30">
        <el-button @click="dialogVisiintroduction = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="Savechange()">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiintbj"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <p class="textalign-left f18">成果估值编辑</p>
      <div class="textalign-left margin-top30">
        <div>
          <p>成果名称</p>
          <el-select
            v-model="achievementbj"
            placeholder="请选择成果"
            class="width100 margin-top10"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in achievements"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p class="margin-top20">备注信息</p>
          <el-input
            placeholder="请输入备注信息"
            v-model="remarkbj"
            type="textarea"
            :autosize="autosize"
            class="inputDeep margin-top10"
            maxlength="500"
            rows="5"
            cols="20"
          >
          </el-input>
        </div>
      </div>
      <div class="but-box textalign-right margin-top30">
        <el-button @click="dialogVisiintbj = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="bjchange()">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <!-- 新增融资 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisifinancing"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <p class="textalign-left f18">成果融资需求</p>
      <div class="textalign-left margin-top30">
        <div>
          <p>融资预期（万元）</p>
          <el-input
            placeholder="请输入融资预期"
            v-model="assessmentprice"
            class="margin-top10"
          >
          </el-input>
        </div>
        <div>
          <p class="margin-top20">融资方式</p>
          <el-input
            placeholder="请输入融资方式"
            v-model="assessmenttype"
            class="margin-top10"
          >
          </el-input>
        </div>
        <div>
          <p class="margin-top20">备注信息</p>
          <el-input
            placeholder="请输入备注信息"
            v-model="assessmentremark"
            type="textarea"
            :autosize="autosize"
            class="inputDeep margin-top10"
            maxlength="500"
            rows="5"
            cols="20"
          >
          </el-input>
        </div>
      </div>
      <div class="but-box textalign-right margin-top30">
        <el-button @click="dialogVisifinancing = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="assessmentsave()">
          保 存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  entassessmentindex,
  entassessmentsave,
  entassessmentdelete,
  entassessmentupdate,
  entachievementsfinancesave,
} from "@/api/business/business.api";
import { entachievementsindex } from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiintroduction: false,
      dialogVisiintbj: false,
      dialogVisifinancing: false,
      serchkey: true,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 0,
      companytitle: "",
      pagination: false,

      allpage: [],
      ruleForm: {
        name: "",
        status: "",
      },
      pagestatus: [
        { name: "待评估", id: 1 },
        { name: "已评估", id: 2 },
      ],
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      remark: "",
      achievement: "",
      remarkbj: "",
      achievementbj: "",
      achievementbjid: "",
      updateid: "",
      achievements: [],
      assessmentid: "",
      assessmentprice: "",
      assessmenttype: "",
      assessmentremark: "",
      defaultid: "",
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `成果名称`, visible: true },
        { key: 1, label: `估值申请时间`, visible: true },
        { key: 2, label: `评估状态`, visible: true },
        { key: 3, label: `评估机构`, visible: true },
        { key: 4, label: `评估值`, visible: true },
        { key: 5, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 下载报告
    downloadreport(row) {
      let a = document.createElement("a");
      a.href = row.report_url;
      a.click();
    },
    // 项目融资
    financing(row) {
      this.dialogVisifinancing = true;
      this.assessmentid = row.id;
    },
    // 融资提交
    assessmentsave() {
      entachievementsfinancesave({
        assessment_id: this.assessmentid,
        price: this.assessmentprice,
        type: this.assessmenttype,
        remark: this.assessmentremark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.dialogVisifinancing = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    Initiateasale() {
      this.dialogVisiintroduction = true;
      entachievementsindex({}).then((res) => {
        if (res.data.code == 200) {
          this.achievements = res.data.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 提交
    Savechange() {
      entassessmentsave({
        achievements_id: this.achievement,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          this.dialogVisiintroduction = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 编辑
    Initiateedit(row) {
      this.dialogVisiintbj = true;
      this.updateid = row.id;
      this.achievementbj = row.achievements.title;
      this.achievementbjid = row.achievements_id;
      this.remarkbj = row.remark;
      entachievementsindex({}).then((res) => {
        if (res.data.code == 200) {
          this.achievements = res.data.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 提交
    bjchange() {
      if (typeof this.achievementbj == "string") {
        this.achievementbj = this.achievementbjid;
      }
      entassessmentupdate({
        id: this.updateid,
        achievements_id: this.achievementbj,
        remark: this.remarkbj,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.dialogVisiintbj = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 清空input
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.thisNum = 1;
      this.limitval = "";
      entassessmentindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      entassessmentindex({
        _keywords: this.ruleForm.name,
        status: this.ruleForm.status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除
    Submitfromnull(row) {
      this.$confirm("此操作将删除此成果评估, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entassessmentdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      entassessmentindex({
        page: val,
        _keywords: this.ruleForm.name,
        status: this.ruleForm.status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entassessmentindex({
        page: 1,
        limit: val,
        _keywords: this.ruleForm.name,
        status: this.ruleForm.status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entassessmentindex({
        page: this.thisNum,
        _keywords: this.ruleForm.name,
        status: this.ruleForm.status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.defaultid = window.sessionStorage.getItem("default");

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    entassessmentindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.grenn {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7b83ea;
  position: relative;
  top: -1px;
  left: -5px;
}
.grenns {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #52c5cb;
  position: relative;
  top: -1px;
  left: -5px;
}

.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>